/**
 * Shared loading / success states for add-to-cart buttons.
 */
(function (window, document) {
  'use strict';

  var SUCCESS_MS = 1400;

  var spinnerHTML =
    '<div class="loading__spinner atc-state-spinner" aria-hidden="true">' +
    '<svg class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle></svg></div>';

  var successHTML =
    '<span class="atc-success-icon" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M5 13l4.5 4.5L19 7.5"/></svg></span>';

  function getButton(el) {
    if (!el || !el.closest) return null;
    return (
      el.closest(
        'button, [type="submit"], .product-card__atc, .product-form__submit, [data-product-atc-button], [data-cart-upsell-submit], .product-card__qty-btn'
      ) || null
    );
  }

  function ensureIcons(button) {
    button = getButton(button);
    if (!button) return null;
    if (!button.querySelector('.loading__spinner')) {
      button.insertAdjacentHTML('beforeend', spinnerHTML);
    }
    if (!button.querySelector('.atc-success-icon')) {
      button.insertAdjacentHTML('beforeend', successHTML);
    }
    return button;
  }

  function clearTimer(button) {
    if (button && button._atcSuccessTimer) {
      clearTimeout(button._atcSuccessTimer);
      button._atcSuccessTimer = null;
    }
  }

  function setLoading(button) {
    button = ensureIcons(button);
    if (!button) return null;
    clearTimer(button);
    button.classList.remove('btn--success');
    button.classList.add('btn--loading');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    return button;
  }

  function reset(button) {
    button = getButton(button);
    if (!button) return;
    clearTimer(button);
    button.classList.remove('btn--loading', 'btn--success');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-busy');
  }

  function setSuccess(button, options) {
    button = ensureIcons(button);
    if (!button) return null;
    options = options || {};
    clearTimer(button);
    button.classList.remove('btn--loading');
    button.classList.add('btn--success');
    button.setAttribute('aria-busy', 'false');
    if (options.hold) return button;
    var ms = typeof options.duration === 'number' ? options.duration : SUCCESS_MS;
    button._atcSuccessTimer = setTimeout(function () {
      reset(button);
    }, ms);
    return button;
  }

  function fromForm(form, submitter) {
    var buttons = [];
    if (submitter) buttons.push(getButton(submitter));
    if (form) {
      var atc = form.querySelector(
        '[data-product-atc-button], [data-cart-upsell-submit], [name="add"], button[type="submit"]'
      );
      if (atc) buttons.push(getButton(atc));
    }
    return buttons.filter(Boolean).filter(function (btn, index, arr) {
      return arr.indexOf(btn) === index;
    });
  }

  window.AtcButtonStates = {
    setLoading: setLoading,
    setSuccess: setSuccess,
    reset: reset,
    ensureIcons: ensureIcons,
    fromForm: fromForm,
    SUCCESS_MS: SUCCESS_MS,
  };
})(window, document);
